import * as types from 'constants/pdfActionTypes';
import * as services from 'services/pdf.service';

export const getPdfActa = (payload) => async (dispatch) => {
  dispatch({ type: types.GET_PDF_LOADING });
  try {
    const response = await services.fetchPdfActas(payload);

    dispatch({
      type: types.GET_PDF_SUCCESS,
      success: true,
      ...response
    });
    return { success: true, response };
  } catch (error) {
    dispatch({ type: types.GET_PDF_FAILURE, error });
    return { succes: false };
  }
};

export const getZipPublico = (payload) => async (dispatch) => {
  dispatch({ type: types.GET_PDF_LOADING });
  try {
    const response = await services.fetchZipPublico(payload);

    dispatch({
      type: types.GET_PDF_SUCCESS,
      success: true,
      ...response
    });
    return { success: true, response };
  } catch (error) {
    dispatch({ type: types.GET_PDF_FAILURE, error });
    return { succes: false };
  }
};
